import React, { Component } from "react"
import Chart from "react-apexcharts"
import colorArray from "helpers/colorArray"

//https://codepen.io/indreed/pen/qBOxJmB
class StackedHorizontalBar extends Component {
	constructor(props) {
		super(props)
		this.ele = React.createRef()
	}

	render() {
		const addAnnotations = (config, chart) => {
			//console.log(config, chart)
			const seriesTotals = config.globals.stackedSeriesTotals
			const isHorizontal = options.plotOptions.bar.horizontal

			try {
				chart.clearAnnotations()
				config.globals.labels.forEach((category, index) => {
					chart.addPointAnnotation(
						{
							y: isHorizontal ? calcHorizontalY(config, index) : seriesTotals[index],
							x: isHorizontal ? 0 : category,
							label: {
								text: `${seriesTotals[index]}`,
							},
						},
						false
					)

					if (isHorizontal) {
						adjustPointAnnotationXCoord(config, index)
					}
				})
			} catch (error) {
				console.log(error)
			}
		}

		const calcHorizontalY = (config, index) => {
			const catLength = config.globals.labels.length
			const yRange = config.globals.yRange[0]
			const minY = config.globals.minY
			const halfBarHeight = yRange / catLength / 2

			return minY + halfBarHeight + 2 * halfBarHeight * (catLength - 1 - index)
		}

		const adjustPointAnnotationXCoord = (config, index) => {
			const gridWidth = config.globals.gridWidth
			const seriesTotal = config.globals.stackedSeriesTotals[index]
			const minY = config.globals.minY
			const yRange = config.globals.yRange[0]
			const xOffset = (gridWidth * (seriesTotal + Math.abs(minY))) / yRange
			const circle = this.ele.current.querySelector(
				`.apexcharts-point-annotations circle:nth-of-type(${index + 1})`
			)
			const labelField = this.ele.current.querySelector(
				`.apexcharts-point-annotations rect:nth-of-type(${index + 1}`
			)
			const labelFieldXCoord = parseFloat(labelField.getAttribute("x"))
			const text = this.ele.current.querySelector(`.apexcharts-point-annotations text:nth-of-type(${index + 1}`)
			labelField.setAttribute("x", labelFieldXCoord + xOffset)
			text.setAttribute("x", xOffset)
			circle.setAttribute("cx", xOffset)
		}
		let options = {
			// Annotions aren't working on stacked horizontal bars.  Just chaos.  The below is saved in case it's fixed or if it's needed in a less complex, normal bar chart
			/* annotations: {
				points: [
					{
						x: "Tri Pointe Homes", // this may be an index?
						y: 2,
						//yAxisIndex: 0,
						//seriesIndex: 0,
						marker: {
							size: 6,
							fillColor: "#fff",
							strokeColor: "#2698FF",
							radius: 2,
						},
						label: {
							borderColor: "#FF4560",
							offsetY: 0,
							offsetX: 0,
							style: {
								color: "#333",
								background: "#FF4560",
							},

							text: "2",
						},
					},
				],
			}, */
			chart: {
				type: "bar",
				//height: 350,
				stacked: true,
				events: {
					mounted: (chartContext, config) => {
						setTimeout(() => {
							//addAnnotations(config, chartContext)
						})
					},
					updated: (chartContext, config) => {
						setTimeout(() => {
							//addAnnotations(config, chartContext)
						})
					},
				},
				toolbar: {
					show: true,
					tools: {
						download: false,
					},
					export: {
						csv: {
							columnDelimiter: ";",
						},
					},
				},
			},
			plotOptions: {
				bar: {
					horizontal: true,
					dataLabels: {
						total: {
							enabled: true,
							style: {
								fontSize: "10px",
							},
						},
					},
				},
			},
			stroke: {
				width: 1,
				colors: ["#fff"],
			},
			xaxis: {
				categories: this.props.categories,
			},
			colors: colorArray,
			fill: {
				opacity: 1,
			},
			legend: {
				position: "top",
				horizontalAlign: "left",
				offsetX: 40,
			},
			dataLabels: {
				enabled: true,
			},
		}
		return (
			<div ref={this.ele}>
				<Chart options={options} series={this.props.series} type="bar" />
			</div>
		)
	}
}

export default StackedHorizontalBar
